
import React from "react";
import { Link } from "react-router-dom";
import "./Footer.scss";
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";

import logo from "../../images/logo.png";
import facebook from "../../images/social/facebook.png";
import instagram from "../../images/social/instagram.png";
import watsapp from "../../images/social/watsapp2.png";

const Footer = (props) => {
  const { t } = useTranslation();

  const requisites = props.requisites || {};

  const hasSocialLinks = !!(
    requisites.whatsAppLink ||
    requisites.facebookLink ||
    requisites.instagramLink
  );

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  };

  return (
    <footer className="site-footer">
      {props.hr ? (
        <hr className="site-footer__external-hr" />
      ) : null}

      <div className="site-footer__top">
        <div className="site-footer__container">
          <Link
            to="/"
            className="site-footer__logo"
            onClick={scrollToTop}
          >
            <img src={logo} alt="Gudema" />
          </Link>

          <nav className="site-footer__nav">
            <Link to="/about" onClick={scrollToTop}>
              {t("footer.about")}
            </Link>

            {!props.isAuth ? (
              <Link to="/about" onClick={scrollToTop}>
                {t("footer.partner")}
              </Link>
            ) : null}

            <Link to="/contacts" onClick={scrollToTop}>
              {t("footer.contacts")}
            </Link>

            <Link
              to="/privacy"
              className="site-footer__privacy-mobile"
              onClick={scrollToTop}
            >
              {t("footer.privacy")}
            </Link>
          </nav>
        </div>
      </div>

      <div className="site-footer__line" />

      <div className="site-footer__bottom">
        <div className="site-footer__container">
          <div className="site-footer__legal">
            <span>{t("footer.copyright")}</span>

            <span className="site-footer__legal-separator">|</span>

            <Link
              to="/privacy"
              className="site-footer__privacy-desktop"
              onClick={scrollToTop}
            >
              {t("footer.privacy")}
            </Link>
          </div>

          {hasSocialLinks ? (
            <div className="site-footer__social">
              <span>{t("footer.followUs")}</span>

              {requisites.whatsAppLink ? (
                <a
                  href={requisites.whatsAppLink}
                  target="_blank"
                  rel="noreferrer"
                  aria-label="WhatsApp"
                  className="site-footer__whatsapp"
                >
                  <img src={watsapp} alt="WhatsApp" />
                </a>
              ) : null}

              {requisites.facebookLink ? (
                <a
                  href={requisites.facebookLink}
                  target="_blank"
                  rel="noreferrer"
                  aria-label="Facebook"
                  className="site-footer__social-link"
                >
                  <img src={facebook} alt="Facebook" />
                </a>
              ) : null}

              {requisites.instagramLink ? (
                <a
                  href={requisites.instagramLink}
                  target="_blank"
                  rel="noreferrer"
                  aria-label="Instagram"
                  className="site-footer__social-link"
                >
                  <img src={instagram} alt="Instagram" />
                </a>
              ) : null}
            </div>
          ) : null}
        </div>
      </div>
    </footer>
  );
};

const mapStateToProps = (state) => ({
  requisites: state.header.requisites,
  isAuth: !!state.auth.authUsername,
});

export default connect(mapStateToProps)(Footer);
